import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';
import { useLanguage } from '../../context/LanguageContext';
import { getBlogPageStructuredData } from '../../utils/structuredData';
import { getPostsByLang, getAllCategories } from '../../data/blogPosts';
import './Blog.css';

const BlogCard = ({ post, lang, t }) => {
  return (
    <article className="blog-card">
      <Link to={`/${lang}/blog/${post.slug}`}>
        <div className="blog-card-content">
          <span className="blog-category">{post.category}</span>
          <h2>{post.title}</h2>
          <p>{post.description}</p>
          <div className="blog-meta">
            <span>{post.datePublished}</span>
            <span>{post.readTime} {t.blog.readTime}</span>
          </div>
        </div>
      </Link>
    </article>
  );
};

const Blog = () => {
  const { lang, t } = useLanguage();
  const posts = getPostsByLang(lang);
  const categories = getAllCategories(lang);
  const baseUrl = 'https://sentmo.com';

  return (
    <>
      <SEO
        title={t.seo.blog.title}
        description={t.seo.blog.description}
        keywords="Trading Blog, Trading Wissen, Sentiment Analyse lernen, Trading Strategien, Trading Tipps, Marktanalyse"
        canonicalUrl={`${baseUrl}/${lang}/blog`}
        lang={lang}
        alternateUrls={[
          { lang: 'de', url: `${baseUrl}/de/blog` },
          { lang: 'en', url: `${baseUrl}/en/blog` },
          { lang: 'x-default', url: `${baseUrl}/de/blog` }
        ]}
        structuredData={getBlogPageStructuredData({
          lang,
          title: t.seo.blog.title,
          description: t.seo.blog.description,
          posts
        })}
      />
      <div className="page blog-page">
        <header className="blog-header">
          <h1>{t.blog.title}</h1>
          <p>{t.blog.subtitle}</p>
        </header>

        <nav className="blog-categories" aria-label="Blog Categories">
          <span className="category-label">{t.blog.categories}</span>
          {categories.map(category => (
            <span key={category} className="category-tag">{category}</span>
          ))}
        </nav>

        <div className="blog-grid">
          {posts.map(post => (
            <BlogCard key={post.id} post={post} lang={lang} t={t} />
          ))}
        </div>

        <section className="blog-cta">
          <h2>{t.blog.cta.title}</h2>
          <p>{t.blog.cta.description}</p>
          <Link to={`/${lang}/sentiment`} className="cta-button">{t.blog.cta.button}</Link>
        </section>
      </div>
    </>
  );
};

export default Blog;
